/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import sizes from './sizes';
/**
 * A locked lock icon.
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.size] The icon size.
 */
export default function LockClosedIcon({ className, size = 'small' }) {
    return (jsx("svg", { xmlns: "http://www.w3.org/2000/svg", sx: {
            width: sizes[size],
            height: sizes[size],
            verticalAlign: 'middle',
        }, className: className, viewBox: "0 0 12 18" },
        jsx("g", { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
            jsx("g", { transform: "translate(-462 -305)" },
                jsx("g", { transform: "translate(180 119)" },
                    jsx("g", { transform: "translate(1 167)" },
                        jsx("g", { transform: "translate(281 16)" },
                            jsx("g", { transform: "translate(0 3)" },
                                jsx("g", null,
                                    jsx("path", { stroke: "currentColor", d: "M.5 7.5v8h10v-8H.5z" }),
                                    jsx("path", { fill: "currentColor", d: "M5.5 12.133c-.299-.198-.5-.567-.5-.99C5 10.512 5.448 10 6 10s1 .512 1 1.143c0 .423-.201.792-.5.99V13.5a.5.5 0 11-1 0v-1.367z" }),
                                    jsx("path", { stroke: "currentColor", d: "M2.5 7.5h6v-4a3 3 0 10-6 0v4z" }))))))))));
}
//# sourceMappingURL=LockClosedIcon.js.map